const NOTE = { C5: 523, D5: 587, E5: 659, FS5: 740 };
let ctx = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

export function primeAudio() {
  getCtx();
}

function tone(freq, start, dur, gain) {
  const c = getCtx();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = "sine";
  o.frequency.value = freq;
  g.gain.setValueAtTime(0, c.currentTime + start);
  g.gain.linearRampToValueAtTime(gain, c.currentTime + start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + start + dur);
  o.connect(g).connect(c.destination);
  o.start(c.currentTime + start);
  o.stop(c.currentTime + start + dur + 0.05);
}

/** level 0: soft two-note chime · 1: brighter triple · 2+: insistent pulsing */
export function playAlarm(level = 0) {
  if (level <= 0) {
    tone(NOTE.C5, 0, 0.5, 0.15);
    tone(NOTE.E5, 0.35, 0.7, 0.15);
  } else if (level === 1) {
    tone(NOTE.D5, 0, 0.3, 0.3);
    tone(NOTE.FS5, 0.3, 0.3, 0.3);
    tone(880, 0.6, 0.5, 0.3);
  } else {
    for (let i = 0; i < 4; i++) {
      tone(880, i * 0.35, 0.18, 0.45);
      tone(1100, i * 0.35 + 0.17, 0.15, 0.45);
    }
  }
}

export const repeatMsForLevel = (level) => (level <= 0 ? 45000 : level === 1 ? 20000 : 8000);
